import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M30,22.8c0,1.1-.8,1.5-1.7,1l-2.6-1.6a4,4,0,0,1-1.7-3V12.8a4,4,0,0,1,1.7-3l2.6-1.6c.9-.5,1.7-.1,1.7,1Z"/><path d="M3.6,7A1.6,1.6,0,0,0,2,8.6V23.4A1.6,1.6,0,0,0,3.6,25H20.4A1.6,1.6,0,0,0,22,23.4V8.6A1.6,1.6,0,0,0,20.4,7ZM12,20a4,4,0,1,1,4-4A4,4,0,0,1,12,20Z"/>';
export var VideoSVG = function VideoSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
VideoSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(VideoSVG);